import React from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import './Footer.css';
import { APP_STORE_IMG, PLAY_STORE_IMG, COMPANY_LOGO, OFFLINE_SELLING_LOGO } from '@/_constant/image-url-constants';
import { getSellCategoriesData } from "@/store/reducer/categoriesListSlice/categories";
import { FACEBOOK, INSTAGRAM, PLAY_STORE, APP_STORE, TWITTER, YOUTUBE, TERMCONDITION, PRIVACYPOLICY, REFUNDPOLiCY, ADSPOLICY, ABOUT_US, CONTACT_US, OFFERZONE, ADZONE, MYPOSTINGS, PAYMENTSUMMARY, DEALER_LISTING, BLOG } from "@/_constant/urlconstants";
import { COMPANY_ADDRESS, COMPANY_EMAIL, COMPANY_FIRST_NAME, COMPANY_NAME, COMPANY_PHONE, POWERED_BY } from '@/_constant/appConstant';
import { useLanguageContext } from '@/hooks/context-hooks';
import MyListing from '@/_component/MyListing/MyListing';

export default function Footer() {
  const { language } = useLanguageContext();
  const navigate = useNavigate();

  return (
    <footer className="container-fluid p-0 bg-light border-top">
      <section className="container py-5 px-2">
        <div className="row gap-3 gap-md-0 text-sm-start text-center">
          <div className="col-lg-3 col-md-6">
            <div className="mb-1">
              <img src={OFFLINE_SELLING_LOGO} alt="PillarX Logo" style={{ height: '40px', width: 'auto' }} />
            </div>
            <div className="download-app">
              <p className="py-2">
                Download the {COMPANY_FIRST_NAME} app & enjoy features
              </p>
              <div className="mb-2">
                <a href={PLAY_STORE}><img className="dowload-app-icon" src={PLAY_STORE_IMG} alt="Download app from google play store" /></a>
              </div>
              <div>
                <a href={APP_STORE}><img className="dowload-app-icon" src={APP_STORE_IMG} alt="Download app from app store" /></a>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <h5 className="pt-3 kg-title-ul">Pages</h5>
            <div className="d-flex flex-column gap-3">
              <Link to={ABOUT_US} className="link-animate-ul">{language("label.about_us")} </Link>
              <Link to={CONTACT_US} className="link-animate-ul">{language("label.contact_us")}</Link>
              <Link to={BLOG} className="link-animate-ul">{language("label.blog") || "Blog"}</Link>
              <Link to={OFFERZONE} className="link-animate-ul" >{language("label.offer_zone")}</Link>
              <Link to={ADZONE} className="link-animate-ul">{language("label.ad_zone")}</Link>
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <h5 className="kg-title-ul pt-3">Terms & Policies</h5>
            <div className="terms-policy">
              <div className="d-flex flex-column gap-3">
                <Link to={TERMCONDITION} className="link link-animate-ul">Terms And Conditions</Link>
                <Link to={PRIVACYPOLICY} className="link link-animate-ul">Privacy Policy</Link>
                <Link to={REFUNDPOLiCY} className="link link-animate-ul">Refund Policy</Link>
                <Link to={ADSPOLICY} className="link link-animate-ul">Ads Policy</Link>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <h5 className="kg-title-ul pt-3">Get in touch</h5>
            <div className="address-sec">
              <address>{COMPANY_ADDRESS}</address>
              <div>
                <i className="bi bi-telephone-fill fs-5 kg-green me-2 mb-3" aria-hidden="true"></i>
                <a className="" href={`tel:${COMPANY_PHONE}`}>{COMPANY_PHONE}</a>
              </div>
              <div>
                <i className="bi bi-envelope-fill fs-5 kg-green me-2" aria-hidden="true"></i>
                <a className="" href={`mailto:${COMPANY_EMAIL}`}>{COMPANY_EMAIL}</a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="kg-bg-gray">
        <div className="container">
          <div className="row py-3">
            <div className="col-12 py-1">
              <div className='d-flex flex-lg-nowrap flex-wrap align-items-center justify-content-center gap-lg-0 gap-3'>
                <div className="copy-right flex-grow-1 text-center text-lg-start">
                  <span>2025 - {new Date().getFullYear()} © {POWERED_BY}. All Rights Reserved.</span>
                </div>
                <div className="d-flex flex-wrap gap-3 justify-content-center justify-content-sm-start py-2">
                  <a href={INSTAGRAM}>
                    <i className="bi fs-4 bi-instagram social-icon instagram"></i>
                  </a>
                  {/* <a href={TWITTER}>
                    <i className="bi fs-4 bi-twitter social-icon twitter"></i>
                  </a> */}
                  <a href={YOUTUBE}>
                    <i className="bi fs-4 bi-youtube social-icon youtube"></i>
                  </a>
                  <a href={FACEBOOK}>
                    <i className="bi fs-4 bi-facebook social-icon facebook"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </footer>
  )
}
